import { LOADING, TOAST } from '../actions'
import dotProp from 'dot-prop-immutable';
import { toast } from 'react-toastify';

const initialState = {
    loading: 0,
    toast: '',
}

export default (state, action) => {
    let state_ = state || initialState;
    switch (action.type) {
        case LOADING:
            return dotProp.set(state_, `loading`, state_.loading += (action.data ? 1 : -1) );
        case TOAST:
            toast.error(action.data)
            console.log('toast', action.data)
            return dotProp.set(state_, `toast`, action.data);
    }
    return state || initialState
}
